// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Default Font Size is 14px on the HTML page, use the below scale to adjust font sizes.

8pt = 0.571rem
10pt = 0.714rem
12pt = 0.857rem
14pt = 1rem (base font size)
18pt = 1.285rem
20pt = 1.428rem
22pt = 1.571rem
24pt = 1.714rem
28pt = 2rem
30pt = 2.142rem
32pt = 2.285rem
*/
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezClocker Supported Media Screen Sizes
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/*------------------------------------------------------
| @Media Small Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Regular Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Tablets
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Laptops
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Desktops
--------------------------------------------------------*/
/* Use http://paletton.com to generate pallets */
.ezBackgroundImage {
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.07) 50%, transparent 50%), linear-gradient(90deg, rgba(255, 255, 255, 0.13) 50%, transparent 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.17) 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.19) 50%);
  background-size: 13px, 29px, 37px, 53px;
}

.ez-float-left {
  float: left;
}

.ez-float-right {
  float: left;
}

.ez-bring-to-front {
  z-index: 9999;
}

.ez-hidden {
  display: none;
}

.ez-topish {
  margin-top: 25%;
}

.ez-full-width {
  width: 100%;
}

button {
  cursor: pointer;
  padding: 6px 24px;
  margin: 2px;
  font-size: 1rem;
  font-family: Roboto, Verdana, Geneva, sans-serif;
  font-weight: normal;
  color: #000000;
  background-color: #FF9900;
  border: 1px solid #6d6e70;
  border-radius: 2px;
  outline-width: 0;
}

button:hover {
  background-color: #ffcc66;
}

button:active {
  background-color: #FF9900;
}

button:focus {
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

button:disabled {
  cursor: default;
  font-weight: normal;
  background-color: #FFC164;
  color: #C67600;
  border-color: #9b5d00;
}

label.buttonSubLabel {
  font-weight: normal;
}

button.fullWidth {
  width: 100%;
}

button.floatRightButton {
  float: right;
}

button.paddButton10 {
  margin-left: 10px;
}

button.headerButton {
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.headerButton:disabled {
  font-weight: normal;
}

button.majorButton {
  font-weight: bold;
  background-color: #ffc500;
  border-color: #6d6e70;
  color: #000000;
}

button.majorButton:hover {
  background-color: #ffdb64;
}

button.majorButton:active {
  border-color: #ffcc66;
}

button.majorButton:disabled {
  background-color: #ffdb64;
  color: #c69800;
  border-color: #c69800;
}

button.ez-marketing-button {
  background-color: #0f4777;
  border-radius: 2px;
  border: 1px solid #032746;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1.285rem;
  font-weight: bold;
  padding: 0.5rem;
  text-decoration: none;
}
button.ez-marketing-button:hover {
  background-color: #1D5D93;
}
button.ez-marketing-button:active {
  background-color: #063861;
}
button.ez-marketing-button:focus {
  background-color: #063861;
}

button.ez-marketing-go-button {
  background-color: #ff9900;
  border-radius: 2px;
  border: 1px solid #032746;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1.285rem;
  font-weight: bold;
  padding: 0.5rem;
  text-decoration: none;
}
button.ez-marketing-go-button:hover {
  background-color: #FFB039;
}
button.ez-marketing-go-button:active {
  background-color: #C67700;
}
button.ez-marketing-go-button:focus {
  background-color: #C67700;
}

button.ez-marketing-button-wide {
  background-color: #0f4777;
  border-radius: 2px;
  border: 1px solid #032746;
  display: inline-block;
  width: 50%;
  cursor: pointer;
  color: #ffffff;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1.285rem;
  font-weight: bold;
  padding: 0.5rem;
  text-decoration: none;
  margin-bottom: 10px;
}
button.ez-marketing-button-wide:hover {
  background-color: #1D5D93;
}
button.ez-marketing-button-wide:active {
  background-color: #063861;
}
button.ez-marketing-button-wide:focus {
  background-color: #063861;
}

a.ez-learn-more-button {
  font-family: "Roboto", Verdana, sans-serif;
  font-weight: normal;
  font-size: 1rem;
  font-style: normal;
  text-decoration: none;
  color: #000000;
  background-color: #ffffff;
  margin-top: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #ffc500;
  padding: 13px;
  border-radius: 25px;
}
a.ez-learn-more-button:focus {
  background-color: #FFD239;
  text-decoration: none;
}
a.ez-learn-more-button:hover {
  background-color: #FFD239;
  text-decoration: none;
}
a.ez-learn-more-button:active {
  background-color: #C69800;
  text-decoration: none;
}

a.ez-marketing-learn-more-button {
  font-family: "Roboto", Verdana, sans-serif;
  font-weight: normal;
  font-size: 1.285rem;
  font-style: normal;
  text-decoration: none;
  color: #000000;
  background-color: #ffffff;
  margin-top: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #ffc500;
  padding: 13px;
  border-radius: 25px;
}
a.ez-marketing-learn-more-button:focus {
  background-color: #FFD239;
  text-decoration: none;
}
a.ez-marketing-learn-more-button:hover {
  background-color: #FFD239;
  text-decoration: none;
}
a.ez-marketing-learn-more-button:active {
  background-color: #C69800;
  font-style: normal;
  text-decoration: none;
}

button.deleteMajorButton {
  margin: 0;
  padding: 6px 24px;
  color: #ffffff;
  background-color: #CE0F0C;
  border-color: #A60400;
}

button.deleteMajorButton:hover {
  background-color: #FF0700;
  color: #ffffff;
}

button.deleteMajorButton:active {
  background-color: #BF3330;
}

button.deleteMajorButton:disabled {
  color: #c0c0c0;
  background-color: #FFf0f0;
  border-color: #c0c0c0;
  cursor: default;
}

Button Styles button.miniMajorButton {
  font-size: 0.517rem;
  font-weight: bold;
  background-color: #ffc500;
  border-color: #6d6e70;
  color: #000000;
  border-radius: 4px;
}

button.miniMajorButton:hover {
  background-color: #ffdb64;
}

button.miniMajorButton:active {
  border-color: #ffcc66;
}

button.miniMajorButton:disabled {
  background-color: #ffdb64;
  color: #c69800;
  border-color: #c69800;
}

button.miniNormalButton {
  font-size: 0.517rem;
  font-weight: normal;
  background-color: #ffc500;
  border-color: #6d6e70;
  color: #000000;
  border-radius: 4px;
}

button.miniNormalButton:hover {
  background-color: #ffdb64;
}

button.miniNormalButton:active {
  border-color: #ffcc66;
}

button.miniNormalButton:disabled {
  background-color: #ffdb64;
  color: #c69800;
  border-color: #c69800;
}

button.warningHeaderButton {
  vertical-align: middle;
  font-size: 0.857rem;
  font-weight: bold;
  background-color: #CE0F0C;
  border-color: #A60400;
  color: #ffffff;
}

button.warningHeaderButton:hover {
  background-color: #FF0700;
  color: #ffffff;
}

button.warningHeaderButton:active {
  color: #ffffff;
  background-color: #BF3330;
}

button.warningHeaderButton:disabled {
  color: #c0c0c0;
  background-color: #FFf0f0;
  border-color: #c0c0c0;
  font-weight: normal;
}

button.editButton {
  vertical-align: middle;
  text-align: center;
  margin: 2;
  font-size: 0.517rem;
  background-color: #0f4777;
  border-color: #032746;
  color: #ffffff;
  padding: 2px 4px;
}

button.editButton:hover {
  background-color: #1D5D93;
}

button.editButton:active {
  background-color: #063861;
}

button.editButton:disabled {
  cursor: default;
  background-color: #3B6F9B;
  color: var(#032746);
}

button.smallButton {
  vertical-align: middle;
  text-align: center;
  font-size: 0.517rem;
  margin: 0 2px 0 0;
  padding: 2px;
  border-color: #a60400;
  background-color: #ff7673;
}

button.smallButton:hover {
  background-color: #ff0700;
  color: #ffffff;
}

button.smallButton:active {
  background-color: #BF3330;
}

button.smallButton:disabled {
  cursor: default;
  color: #808080;
  border-color: #c0c0c0;
  padding: 2px;
  background-color: #f0f0f0;
}

img.miniButtonIcon {
  width: 24px;
  border-style: none;
  vertical-align: middle;
  padding-right: 4px;
}

button.miniActionButton {
  font-size: 0.517rem;
  padding: 2px;
  margin: 0;
  font-weight: bold;
  border-radius: 2px;
  color: #000000;
  background-color: #ffc500;
  border-color: #9b7800;
  cursor: pointer;
}

button.miniActionButton:hover {
  background-color: #ffdb64;
}

button.miniActionButton:active {
  background-color: #c69800;
}

button.miniActionButton:disabled {
  background-color: #c69800;
  border-color: #808080;
  color: #ffc500;
  cursor: default;
}

button.miniDeleteActionButton {
  font-size: 0.517rem;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px;
  margin: 0;
  color: #ffffff;
  background-color: #CE0F0C;
  border-color: #A60400;
  cursor: pointer;
}

button.miniDeleteActionButton:hover {
  background-color: #FF0700;
  color: #ffffff;
}

button.miniDeleteActionButton:active {
  background-color: #BF3330;
}

button.miniDeleteActionButtonn:disabled {
  color: #c0c0c0;
  background-color: #FFf0f0;
  border-color: #c0c0c0;
  cursor: default;
}

button.actionButton {
  margin: 0;
  background-color: #8df13c;
  border-color: #439400;
  font-weight: bold;
  padding: 6px 24px;
}

button.actionButton:hover {
  background-color: #caff9e;
}

button.actionButton:active {
  color: #caff9e;
  background-color: #439400;
}

button.actionButton:disabled {
  cursor: default;
  background-color: #caff9e;
  border-color: #8df13c;
  font-weight: normal;
  color: #808080;
}

button.superActionButton {
  margin: 0;
  background-color: #0f4777;
  border-color: #6d6e70;
  color: #ffffff;
  font-weight: bold;
  font-size: 1.285rem;
  padding: 6px 24px;
}

button.superActionButton:hover {
  background-color: #0d58a6;
}

button.superActionButton:active {
  background-color: #0d58a6;
}

button.superActionButton:disabled {
  cursor: default;
  background-color: #5387bd;
  border-color: #0f4777;
  font-weight: normal;
  color: #0f4777;
}

/* Tab Buttons */
.ezTabButton {
  margin: 0 4px 0 0;
  min-height: 32;
  border-style: solid;
  border-width: 1px;
  border-color: #000000;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #c0c0c0;
  outline-style: none;
  color: #000000;
  box-shadow: none;
}

.ezTabButton:HOVER {
  background-color: #e0e0e0;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabButton:ACTIVE {
  background-color: #ffffff;
  border-bottom-width: 2px;
  border-bottom-color: #ffffff;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabButton:FOCUS {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabButtonActive {
  margin: 0 4px 0 0;
  min-height: 32;
  font-weight: bold;
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabButtonActive:HOVER {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabButtonActive:ACTIVE {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabButtonActive:FOCUS {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

/* Paper Buttons */
paper-button.ez-navigation-button {
  max-height: 32px;
  max-width: 175px;
  min-width: 32px;
  font-size: 1rem;
  font-weight: bold;
  background-color: #ff9900;
  color: #000000;
  text-transform: capitalize;
}

paper-button.ez-navigation-button > paper-ripple {
  color: var(#ffffff);
}

paper-button.ez-navigation-button:hover {
  background-color: #ff9900;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

paper-button.ez-signout-button {
  text-transform: capitalize;
  max-height: 32px;
  max-width: 175px;
  min-width: 32px;
  font-size: 1rem;
  font-weight: bold;
  background-color: #316dac;
  color: var(#ffffff);
}

paper-button.ez-signout-button > paper-ripple {
  color: var(#ffffff);
}

paper-button.ez-signout-button:hover {
  background-color: #1058A3;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

paper-button.ez-select-plan-button {
  max-width: 175px;
  min-width: 32px;
  max-height: 32px;
  font-size: 1rem;
  font-weight: bold;
  background-color: var(#8EF13C);
  color: #000000;
  text-transform: capitalize;
}

paper-button.ez-select-plan-button > paper-ripple {
  color: #65DF00;
}

paper-button.ez-select-plan-button:hover {
  background-color: #A5F562;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/* INPUT BUTTONS */
input[type=button].ez-major-button {
  background-color: #ff9900;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=button].ez-major-button:hover {
  background-color: #ffcc66;
}

input[type=button].ez-major-button:active {
  background-color: #ff9933;
}

input[type=button].ez-action-button {
  background-color: #8df13c;
  border-radius: 2px;
  border: 1px solid #439400;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=button].ez-marketing-input-button {
  background-color: #0f4777;
  border-radius: 2px;
  border: 1px solid #032746;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1.285rem;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}
input[type=button].ez-marketing-input-button:hover {
  background-color: #1D5D93;
}
input[type=button].ez-marketing-input-button:active {
  background-color: #063861;
}
input[type=button].ez-marketing-input-button:focus {
  background-color: #063861;
}

input[type=button].ez-action-button {
  background-color: #8df13c;
  border-radius: 2px;
  border: 1px solid #439400;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=button].ez-action-button:hover {
  background-color: #caff9e;
}

input[type=button].ez-action-button:active {
  color: #caff9e;
  background-color: #439400;
}

input[type=button].ez-edit-button {
  background-color: #f0f0f0;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: normal;
  padding: 4px;
  text-decoration: none;
}

input[type=button].ez-edit-button:hover {
  background-color: #edf6ff;
}

input[type=button].ez-edit-button:active {
  background-color: #c0c0c0;
}`, "",{"version":3,"sources":["webpack://./ezlibrary/welcome/css/ez-responsive.scss","webpack://./ezlibrary/welcome/css/ez-core.scss","webpack://./ezlibrary/welcome/css/ez-buttons.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;CAAA;AAyDA;;yDAAA;AAaA;;yDAAA;AAOA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;ACnGA,gDAAA;AA0LA;EACI,gTAAA;EAIA,uCAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,eAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AAhBA;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eF7ByB;EE8BzB,gDAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAmBJ;;AAjBA;EACI,yBAAA;AAoBJ;;AAlBA;EACI,yBAAA;AAqBJ;;AAnBA;EACI,0CAAA;AAsBJ;;AApBA;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAuBJ;;AAlBA;EACI,mBAAA;AAqBJ;;AAnBA;EACI,WAAA;AAsBJ;;AApBA;EACI,YAAA;AAuBJ;;AArBA;EACI,iBAAA;AAwBJ;;AAnBA;EACI,sBAAA;EACA,eAAA;EACA,iBAAA;AAsBJ;;AApBA;EACI,mBAAA;AAuBJ;;AAlBA;EACI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAqBJ;;AAnBA;EACI,yBAAA;AAsBJ;;AApBA;EACI,qBAAA;AAuBJ;;AArBA;EACI,yBAAA;EACA,cAAA;EACA,qBAAA;AAwBJ;;AApBA;EACI,yBDrHY;ECsHZ,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cDlHa;ECmHb,0CAAA;EACA,mBF7GyB;EE8GzB,iBAAA;EACA,eAAA;EACA,qBAAA;AAuBJ;AAtBI;EACI,yBD5FM;ACoHd;AAtBI;EACI,yBD9FK;ACsHb;AAtBI;EACI,yBDjGK;ACyHb;;AApBA;EACI,yBD7Ic;EC8Id,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cDzIa;EC0Ib,0CAAA;EACA,mBFpIyB;EEqIzB,iBAAA;EACA,eAAA;EACA,qBAAA;AAuBJ;AAtBI;EACI,yBD3HQ;ACmJhB;AAtBI;EACI,yBD7HO;ACqJf;AAtBI;EACI,yBDhIO;ACwJf;;AAnBA;EACI,yBDpKY;ECqKZ,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,cDlKa;ECmKb,0CAAA;EACA,mBF7JyB;EE8JzB,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AAsBJ;AArBI;EACI,yBD7IM;ACoKd;AArBI;EACI,yBD/IK;ACsKb;AArBI;EACI,yBDlJK;ACyKb;;AAlBA;EACI,0CAAA;EACA,mBAAA;EACA,eFlLyB;EEmLzB,kBAAA;EACA,qBAAA;EACA,cD5La;EC6Lb,yBD5La;EC6Lb,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBDvMc;ECwMd,aAAA;EACA,mBAAA;AAqBJ;AApBI;EACI,yBDxJQ;ECyJR,qBAAA;AAsBR;AApBI;EACI,yBD5JQ;EC6JR,qBAAA;AAsBR;AApBI;EACI,yBD/JO;ECgKP,qBAAA;AAsBR;;AAlBA;EACI,0CAAA;EACA,mBAAA;EACA,mBF7MyB;EE8MzB,kBAAA;EACA,qBAAA;EACA,cDxNa;ECyNb,yBDxNa;ECyNb,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBDnOc;ECoOd,aAAA;EACA,mBAAA;AAqBJ;AApBI;EACI,yBDpLQ;ECqLR,qBAAA;AAsBR;AApBI;EACI,yBDxLQ;ECyLR,qBAAA;AAsBR;AApBI;EACI,yBD3LO;EC4LP,kBAAA;EACA,qBAAA;AAsBR;;AAhBA;EACI,SAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAmBJ;;AAjBA;EACI,yBAAA;EACA,cAAA;AAoBJ;;AAlBA;EACI,yBAAA;AAqBJ;;AAnBA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAsBJ;;AAlBA;EACI,mBFpQuB;EEqQvB,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAqBJ;;AAnBA;EACI,yBAAA;AAsBJ;;AApBA;EACI,qBAAA;AAuBJ;;AArBA;EACI,yBAAA;EACA,cAAA;EACA,qBAAA;AAwBJ;;AApBA;EACI,mBFzRuB;EE0RvB,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAuBJ;;AArBA;EACI,yBAAA;AAwBJ;;AAtBA;EACI,qBAAA;AAyBJ;;AAvBA;EACI,yBAAA;EACA,cAAA;EACA,qBAAA;AA0BJ;;AAtBA;EACI,sBAAA;EACA,mBF7SwB;EE8SxB,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAyBJ;;AAvBA;EACI,yBAAA;EACA,cAAA;AA0BJ;;AAxBA;EACI,cAAA;EACA,yBAAA;AA2BJ;;AAzBA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AA4BJ;;AAxBA;EACI,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBFzUuB;EE0UvB,yBDrVY;ECsVZ,qBD/SW;ECgTX,cD/Ua;ECgVb,gBAAA;AA2BJ;;AAzBA;EACI,yBDtTU;ACkVd;;AA1BA;EACI,yBDxTS;ACqVb;;AA3BA;EACI,eAAA;EACA,yBD9TU;EC+TV,mBDtT+B;ACoVnC;;AA1BA;EACI,sBAAA;EACA,kBAAA;EACA,mBF/VuB;EEgWvB,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;AA6BJ;;AA3BA;EACI,yBAAA;EACA,cAAA;AA8BJ;;AA5BA;EACI,yBAAA;AA+BJ;;AA7BA;EACI,eAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;AAgCJ;;AA5BA;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AA+BJ;;AA7BA;EACI,mBF5XuB;EE6XvB,YAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAgCJ;;AA9BA;EACI,yBAAA;AAiCJ;;AA/BA;EACI,yBAAA;AAkCJ;;AAhCA;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AAmCJ;;AA9BA;EACI,mBFtZuB;EEuZvB,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAiCJ;;AA/BA;EACI,yBAAA;EACA,cAAA;AAkCJ;;AAhCA;EACI,yBAAA;AAmCJ;;AAjCA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAoCJ;;AA/BA;EACI,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AAkCJ;;AAhCA;EACI,yBAAA;AAmCJ;;AAjCA;EACI,cAAA;EACA,yBAAA;AAoCJ;;AAlCA;EACI,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAqCJ;;AAhCA;EACI,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBF1cyB;EE2czB,iBAAA;AAmCJ;;AAjCA;EACI,yBAAA;AAoCJ;;AAlCA;EACI,yBAAA;AAqCJ;;AAnCA;EACI,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAsCJ;;AAlCA,gBAAA;AAGA;EACI,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAmCJ;;AAjCA;EACI,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAoCJ;;AAlCA;EACI,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAqCJ;;AAnCA;EACI,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAsCJ;;AAjCA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EAEA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAmCJ;;AAjCA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAoCJ;;AAlCA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAqCJ;;AAnCA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAsCJ;;AAnCA,kBAAA;AAGA;EACI,gBA/kBqB;EAglBrB,gBA/kBoB;EAglBpB,eA/kBoB;EAglBpB,eFlkByB;EEmkBzB,iBA/kBsB;EAglBtB,yBDvjBO;ECwjBP,cDreM;ECseN,0BAnlByB;AAunB7B;;AAlCA;EACI,mBDpeM;ACygBV;;AAnCA;EACI,yBAplBoB;EAqlBpB,+GAAA;AAsCJ;;AAjCA;EACI,0BAhmByB;EAimBzB,gBApmBqB;EAqmBrB,gBApmBoB;EAqmBpB,eApmBoB;EAqmBpB,eFvlByB;EEwlBzB,iBApmBsB;EAqmBtB,yBDxlBY;ECylBZ,mBDrfM;ACyhBV;;AAlCA;EACI,mBDxfM;AC6hBV;;AAnCA;EACI,yBDnkBS;ECokBT,+GAAA;AAsCJ;;AAjCA;EACI,gBAtnBoB;EAunBpB,eAtnBoB;EAunBpB,gBAznBqB;EA0nBrB,eF1mByB;EE2mBzB,iBAvnBsB;EAwnBtB,8BDliBY;ECmiBZ,cD7gBM;EC8gBN,0BA3nByB;AA+pB7B;;AAlCA;EACI,cDniBY;ACwkBhB;;AAnCA;EACI,yBDxiBiB;ECyiBjB,+GAAA;AAsCJ;;AAnCA,kBAAA;AAGA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AAoCJ;;AAlCA;EACI,yBAAA;AAqCJ;;AAnCA;EACI,yBAAA;AAsCJ;;AApCA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AAuCJ;;AAnCA;EACI,yBD5qBY;EC6qBZ,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cDzqBa;EC0qBb,0CAAA;EACA,mBFpqByB;EEqqBzB,iBAAA;EACA,iBAAA;EACA,qBAAA;AAsCJ;AArCI;EACI,yBDnpBM;AC0rBd;AArCI;EACI,yBDrpBK;AC4rBb;AArCI;EACI,yBDxpBK;AC+rBb;;AAlCA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AAqCJ;;AAnCA;EACI,yBAAA;AAsCJ;;AApCA;EACI,cAAA;EACA,yBAAA;AAuCJ;;AAnCA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAsCJ;;AApCA;EACI,yBAAA;AAuCJ;;AArCA;EACI,yBAAA;AAwCJ","sourcesContent":["/*\r\nDefault Font Size is 14px on the HTML page, use the below scale to adjust font sizes.\r\n\r\n8pt = 0.571rem\r\n10pt = 0.714rem\r\n12pt = 0.857rem\r\n14pt = 1rem (base font size)\r\n18pt = 1.285rem\r\n20pt = 1.428rem\r\n22pt = 1.571rem\r\n24pt = 1.714rem\r\n28pt = 2rem\r\n30pt = 2.142rem\r\n32pt = 2.285rem\r\n*/\r\n\r\n// Responseive Font Sizes\r\n$ezResponsivePicoFontSize: 0.517rem;\r\n$ezResponsiveMicroFontSize: 0.714rem;\r\n$ezResponsiveSmallFontSize: 0.857rem;\r\n$ezResponsiveNormalFontSize: 1rem;\r\n$ezResponsiveMediumFontSize: 1.285rem;\r\n$ezResponsiveLargeFontSize: 1.428rem;\r\n$ezResponsiveExtraLargeFontSize: 1.571rem;\r\n$ezResponsiveHugeFontSize: 1.714rem;\r\n$ezResponsiveExtraHugeFontSize: 2rem;\r\n$ezResponsiveMassiveFontSize: 2.142rem;\r\n$ezResponsiveExtraMassiveFontSize: 2.285rem;\r\n\r\n// Responseive Font Sizes\r\n$ezResponsiveMarketingPicoFontSize: $ezResponsiveMicroFontSize;\r\n$ezResponsiveMarketingMicroFontSize: $ezResponsiveSmallFontSize;\r\n$ezResponsiveMarketingSmallFontSize: $ezResponsiveNormalFontSize;\r\n$ezResponsiveMarketingNormalFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveMarketingMediumFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveMarketingLargeFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveMarketingExtraLargeFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingHugeFontSize: $ezResponsiveExtraHugeFontSize;\r\n$ezResponsiveMarketingExtraHugeFontSize: $ezResponsiveMassiveFontSize;\r\n$ezResponsiveMarketingMassiveFontSize: $ezResponsiveExtraMassiveFontSize;\r\n$ezResponsiveMarketingSuperFontSize: 2.428rem;\r\n\r\n// Responsive Normal Header and Title Font Sizes\r\n$ezResponsiveHeaderFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveSubHeaderFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveTitleFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveLabelFontSize: $ezResponsiveMediumFontSize;\r\n\r\n// Responsive Marketing Header and Title Font Sizes\r\n$ezResponsiveMarketingHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingSubHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingTitleFontSize: $ezResponsiveHugeFontSize;\r\n\r\n$ezRespnsiveLogoWidth: 100%;\r\n$ezResponseLogoHeight: auto;\r\n\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezClocker Supported Media Screen Sizes\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\n$ezSmallMobileMinWidth: 240;\r\n$ezSmallMobileMaxWidth: 319;\r\n$ezMobileMinWidth: 320px;\r\n$ezMobileMaxWidth: 480px;\r\n$ezTabletMinWidth: 481px;\r\n$ezTabletMaxWidth: 1023px;\r\n$ezLaptopMinWidth: 1024px;\r\n$ezLaptopMaxWidth: 1919px;\r\n$ezDesktopMinWidth: 1920px;\r\n\r\n/*------------------------------------------------------\r\n| @Media Small Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (max-width: $ezSmallMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Regular Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezMobileMinWidth) and\r\n    (max-width: $ezMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Tablets\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezTabletMinWidth) and\r\n    (max-width: $ezTabletMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Laptops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezLaptopMinWidth) and\r\n    (max-width: $ezLaptopMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Desktops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezDesktopMinWidth) {\r\n}\r\n\r\n","@use 'ez-responsive.scss';\r\n\r\n/* Use http://paletton.com to generate pallets */\r\n\r\n// Primary ezClocker Colors\r\n$ezClockerOrange: #ff9900;\r\n$ezClockerNavy: #0f4777; // rgb(15,71,119)\r\n$ezClockerYellow: #ffc500;\r\n$ezClockerGray: #6d6e70; // rgb(109,110,112)\r\n$ezClockerAquaGray: #6a737d;\r\n$ezClockerSilver: #e0e0e0; // rgb(224,224,224)\r\n$ezClockerActionGreen: #8EF13C;\r\n$ezClockerAlertRed: #FF0700;\r\n$ezClockerBlack: #000000;\r\n$ezClockerWhite: #ffffff;\r\n\r\n// Specail Use Colors\r\n$ezClockerSmokeyTooth: #f7f4ec;\r\n$ezClockerBackground: #E1E1E1;\r\n\r\n// Rarely Used Legacy Colors\r\n$ezClockerAqua: #316dac;\r\n$ezClockerBlue: #2419b2;\r\n$ezClockerBabyBlue: #7CD0FD;\r\n\r\n// ezClocker Smokey Tooth Shades (#f7f4ec)\r\n$ezSmokeyTooth: $ezClockerSmokeyTooth;\r\n$ezSmokeyToothLight: $ezClockerWhite;\r\n$ezSmokeyToothHover: #FFFEFC;\r\n$ezDarkSmokeyTooth: #D0CBBC;\r\n$ezBorderSmokeyTooth: #AFA68E;\r\n\r\n// ezClocker Orange Shades (#ff9900)\r\n$ezOrange: #ff9900;\r\n$ezLightOrange: #FFC164;\r\n$ezHoverOrange: #FFB039;\r\n$ezDarkOrange: #C67700;\r\n$ezBorderOrange: #9B5D00;\r\n\r\n// ezClocker Navy Shades (#0f4777)\r\n$ezNavy: var($ezClockerNavy);\r\n$ezNavyContainerTextColor: var($ezClockerWhite);\r\n$ezLightNavy: #3B6F9B;\r\n$ezHoverNavy: #1D5D93;\r\n$ezDarkNavy: #063861;\r\n$ezBorderNavy: #032746;\r\n$ezAqua: var($ezClockerAqua);\r\n$ezLightAqua: #7AA7D5;\r\n$ezHoverAqua: #4F85BE;\r\n$ezDarkAqua: #1058A3;\r\n$ezBorderAqua: #0A417A;\r\n$ezNavyContainerDisabledTextColor: var($ezBorderNavy);\r\n$ezNavyAlpha: rgba(15, 71, 119, 0.8);\r\n\r\n// ezClocker yellow shades (#ffc500)\r\n$ezYellow: var($ezClockerYellow);\r\n$ezYelloContainerText: #000000;\r\n$ezLightYellow: #FFDB64;\r\n$ezHoverYellow: #FFD239;\r\n$ezDarkYellow: #C69800;\r\n$ezBorderYellow: #9B7800;\r\n\r\n// ezClocker Gray shades (#6d6e70)\r\n$ezGrayAlpha: rgba(109, 110, 112, 0.9);\r\n$ezGray: $ezClockerGray;\r\n$ezGrayContainerText: $ezClockerWhite;\r\n$ezLightGray: #B2B3B4;\r\n$ezHoverGray: #8A8B8D;\r\n$ezDarkGray: #515255;\r\n$ezBorderGray: #323437;\r\n\r\n// ezClocker Aqua Gray Shared\r\n$ezAquaGray: $ezClockerGray;\r\n$ezAquaGrayContainerText: $ezClockerBackground;\r\n$ezLightAquaGray: #B7BABE;\r\n$ezHoverAquaGray: #898F96;\r\n$ezDarkAquaGray: #505B67;\r\n$ezBorderAquaGray: #374350;\r\n\r\n// ezClocker Blue Shades (#2419b2)\r\n$ezBlue: var($ezClockerGray);\r\n$ezLightBlue: #665EC6;\r\n$ezHoverBlue: #463DB7;\r\n$ezDarkBlue: #1B128A;\r\n$ezBorderBlue: #120B6D;\r\n\r\n// ezClocker silver shares (#e0e0e0)\r\n$ezSilverAlpha: rgba(224, 224, 224, 0.8);\r\n$ezSilver: var($ezClockerSilver);\r\n$ezLightSilver: #f0f0f0;\r\n$ezDarkSilver: #B3B3B3;\r\n$ezBorderSilver: #878686;\r\n\r\n// ezClocker ActionGreen shaes (#8EF13C)\r\n$ezActionGreen: var($ezClockerActionGreen);\r\n$ezLightActionGreen: #C0F991;\r\n$ezHoverActionGreen: #A5F562;\r\n$ezDarkGreen: #77ED16;\r\n$ezBorderGreen: #65DF00;\r\n\r\n// ezClocker AlertRed shades (#FF0700)\r\n$ezAlertText: var($ezClockerWhite);\r\n$ezAlertRed: var($ezClockerAlertRed);\r\n$ezLightAlertRed: #FF6864;\r\n$ezHoverAlertRed: #FF3E39;\r\n$ezDarkAlertRed: #C60500;\r\n$ezBorderAlertRed: #9B0400;\r\n\r\n// ezClocker BabyBlue (#7CD0FD) Shades\r\n$ezBabyBlue: var($ezClockerBabyBlue);\r\n$ezLightBabyBlue: #E8F7FF;\r\n$ezHoverBabyBlue: #A9E0FE;\r\n$ezDarkBabyBlue: #54C0FA;\r\n$ezBorderBabyBlue: #2CACF1;\r\n\r\n// Black Shades\r\n$ezBlack: #000000;\r\n$ezLightBlack: #7F7E7E;\r\n$ezHoverBlack: #464646;\r\n\r\n// White Shades\r\n$ezWhite: var($ezClockerWhite);\r\n$ezDarkWhite: #CECECE;\r\n$ezBorderWhite: #A2A0A0;\r\n\r\n// Background Colors\r\n$ezBackgroundColor: $ezClockerBackground;\r\n$ezAlphaBackgroundColor: rgba(225, 225, 225, .3);\r\n$ezAlphaDarkBackgroundColor: rgba(225, 225, 225, .8);\r\n$ezGrayAlphaBackgroundColor: rgba(128, 128, 128, .4);\r\n$ezDarkBackgroundColor: #B4B4B4;\r\n$ezDarkAlphaBackgroundColor: rgba(180, 180, 180, .3);\r\n\r\n$ezBorderBackgrounColor: #888787;\r\n$ezBorderAlphaBackgroundColor: rgba(136, 135, 135, .3);\r\n\r\n$ezBackgroundImageGradientAlphaWhite1: rgba(255, 255, 255, .07);\r\n$ezBackgroundImageGradientAlphaWhite2: rgba(255, 255, 255, .13);\r\n$ezBackgroundImageGradientAlphaWhite3: rgba(255, 255, 255, .17);\r\n$ezBackgroundImageGradientAlphaWhite4: rgba(255, 255, 255, .19);\r\n\r\n// Text Colors\r\n$ezTextColor: $ezClockerBlack;\r\n$ezLightTextColor: $ezClockerGray;\r\n$ezTitleTextColor: $ezClockerNavy;\r\n$ezHeaderTextColor: $ezClockerBlack;\r\n$ezSubHeaderTextColor: $ezClockerNavy;\r\n\r\n// Font Family\r\n$ezFontFamilyRoboto: 'Roboto';\r\n$ezFontFamilyVerdana: Verdana;\r\n$ezFontFamilySansSerif: sans-serif;\r\n\r\n// Normal Font Sizes\r\n$ezFontSize: 14pt;\r\n\r\n$ezPicoFontSize: 8pt;\r\n$ezMicroFontSize: 10pt;\r\n$ezSmallFontSize: 12pt;\r\n$ezNormalFontSize: $ezFontSize;\r\n$ezMediumFontSize: 18pt;\r\n$ezLargeFontSize: 20pt;\r\n$ezExtraLargeFontSize: 22pt;\r\n\r\n// Normal Header and Title Font Sizes\r\n$ezHeaderFontSize: $ezExtraLargeFontSize;\r\n$ezSubHeaderFontSize: $ezMediumFontSize;\r\n$ezTitleFontSize: $ezLargeFontSize;\r\n\r\n// Marketing Font Sizes\r\n$ezMarketingPicoFontSize: $ezMicroFontSize;\r\n$ezMarketingMicroFontSize: $ezSmallFontSize;\r\n$ezMarketingSmallFontSize: $ezNormalFontSize;\r\n$ezMarketingNormalFontSize: $ezMediumFontSize;\r\n$ezMarketingMediumFontSize: $ezLargeFontSize;\r\n$esMarketingLargeFontSize: $ezExtraLargeFontSize;\r\n$ezMarketingExtraLargeFontSize: 24pt;\r\n\r\n// Marketing Header and Title Font Sizes\r\n$ezMarketingHeaderFontSize: $ezMarketingExtraLargeFontSize;\r\n$ezMarketingSubHeaderFontSize: $ezMarketingMediumFontSize;\r\n$ezMarketingTitleFontSize: $esMarketingLargeFontSize;\r\n\r\n// margins and padding/\r\n$ezDefaultMarginSize: 0;\r\n$ezDefaultPaddingSize: 0;\r\n\r\n// Background Images\r\n.ezBackgroundImage {\r\n    background-image: linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite1 50%, transparent 50%),\r\n    linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite2 50%, transparent 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite3 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite4 50%);\r\n    background-size: 13px, 29px, 37px, 53px;\r\n}\r\n\r\n.ez-float-left {\r\n    float: left\r\n}\r\n\r\n.ez-float-right {\r\n    float: left\r\n}\r\n\r\n.ez-bring-to-front {\r\n    z-index: 9999;\r\n}\r\n\r\n.ez-hidden {\r\n    display: none;\r\n}\r\n\r\n.ez-topish {\r\n    margin-top: 25%;\r\n}\r\n\r\n.ez-full-width {\r\n    width: 100%;\r\n}\r\n","@use 'ez-core';\r\n@use 'ez-responsive';\r\n\r\n// large buttons\r\n$ezLargeButtonMaxHeight: 32px;\r\n$ezLargeButtonMaxWidth: 175px;\r\n$ezLargeButtonMinWidth: 32px;\r\n$ezLargeButtonTextTransform: capitalize;\r\n$ezLargeButtonFontWeight: bold;\r\n\r\n// navigation\r\n$ezNavButtonColor: ez-core.$ezOrange;\r\n$ezNavButtonColorHover: #ff9900;\r\n$ezNavButtonTextColor: ez-core.$ezBlack;\r\n$ezNavButtonFontSize: ez-responsive.$ezResponsiveNormalFontSize;\r\n$ezNavButtonFontWeight: $ezLargeButtonFontWeight;\r\n$ezNavButtonMaxHeight: $ezLargeButtonMaxHeight;\r\n$ezNavButtonTextTransform: $ezLargeButtonTextTransform;\r\n$ezNavButtonMaxWidth: $ezLargeButtonMaxWidth;\r\n$ezNavButtonMinWidth: $ezLargeButtonMinWidth;\r\n$ezNavButtonRippleEffect: ez-core.$ezWhite;\r\n\r\n// sign out\r\n$ezSignOutButtonColor: ez-core.$ezClockerAqua;\r\n$ezSignOutButtonTextColor: ez-core.$ezWhite;\r\n$ezSignOutButtonFontSize: ez-responsive.$ezResponsiveNormalFontSize;\r\n$ezSignOutButtonHoverColor: ez-core.$ezDarkAqua;\r\n$ezSignOutButtonFontWeight: $ezLargeButtonFontWeight;\r\n$ezSignOutButtonTextTransform: $ezLargeButtonTextTransform;\r\n$ezSignOutButtonMaxHeight: $ezLargeButtonMaxHeight;\r\n$ezSignOutButtonMaxWidth: $ezLargeButtonMaxWidth;\r\n$ezSignOutButtonMinWidth: $ezLargeButtonMinWidth;\r\n\r\n// select plan\r\n$ezSelectPlanBtnColor: ez-core.$ezActionGreen;\r\n$ezSelectPlanBtnTextColor: ez-core.$ezBlack;\r\n$ezSelectPlanBtnFontSize: ez-responsive.$ezResponsiveNormalFontSize;\r\n$ezSelectPlanBtnHoverColor: ez-core.$ezHoverActionGreen;\r\n$ezSelectPlanBtnFontWeight: $ezLargeButtonFontWeight;\r\n$ezSelectPlanTextTransform: $ezLargeButtonTextTransform;\r\n$ezSelectPlanBtnMaxHeight: $ezLargeButtonMaxHeight;\r\n$ezSelectPlanButtonMaxWidth: $ezLargeButtonMaxWidth;\r\n$ezSelectPlanButtonMinWidth: $ezLargeButtonMinWidth;\r\n\r\n// Global Button Styles\r\nbutton {\r\n    cursor: pointer;\r\n    padding: 6px 24px;\r\n    margin: 2px;\r\n    font-size: ez-responsive.$ezResponsiveNormalFontSize;\r\n    font-family: Roboto, Verdana, Geneva, sans-serif;\r\n    font-weight: normal;\r\n    color: #000000;\r\n    background-color: #FF9900;\r\n    border: 1px solid #6d6e70;\r\n    border-radius: 2px;\r\n    outline-width: 0;\r\n}\r\nbutton:hover {\r\n    background-color: #ffcc66;\r\n}\r\nbutton:active {\r\n    background-color: #FF9900;\r\n}\r\nbutton:focus {\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, .3);\r\n}\r\nbutton:disabled {\r\n    cursor: default;\r\n    font-weight: normal;\r\n    background-color: #FFC164;\r\n    color: #C67600;\r\n    border-color: #9b5d00;\r\n}\r\n\r\n\r\n// Other Button Related Styles\r\nlabel.buttonSubLabel {\r\n    font-weight: normal;\r\n}\r\nbutton.fullWidth {\r\n    width: 100%;\r\n}\r\nbutton.floatRightButton {\r\n    float: right;\r\n}\r\nbutton.paddButton10 {\r\n    margin-left: 10px;\r\n}\r\n\r\n\r\n// Header Button Styles\r\nbutton.headerButton {\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\nbutton.headerButton:disabled {\r\n    font-weight: normal;\r\n}\r\n\r\n\r\n// Major Button Styles\r\nbutton.majorButton {\r\n    font-weight: bold;\r\n    background-color: #ffc500;\r\n    border-color: #6d6e70;\r\n    color: #000000;\r\n}\r\nbutton.majorButton:hover {\r\n    background-color: #ffdb64;\r\n}\r\nbutton.majorButton:active {\r\n    border-color: #ffcc66;\r\n}\r\nbutton.majorButton:disabled {\r\n    background-color: #ffdb64;\r\n    color: #c69800;\r\n    border-color: #c69800;\r\n}\r\n\r\n// ez-marketing-button\r\nbutton.ez-marketing-button {\r\n    background-color: ez-core.$ezClockerNavy;\r\n    border-radius: 2px;\r\n    border: 1px solid ez-core.$ezBorderNavy;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: ez-core.$ezClockerWhite;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n    font-weight: bold;\r\n    padding: 0.5rem;\r\n    text-decoration: none;\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverNavy;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n    &:focus {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n}\r\n\r\nbutton.ez-marketing-go-button {\r\n    background-color: ez-core.$ezClockerOrange;\r\n    border-radius: 2px;\r\n    border: 1px solid ez-core.$ezBorderNavy;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: ez-core.$ezClockerWhite;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n    font-weight: bold;\r\n    padding: 0.5rem;\r\n    text-decoration: none;\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverOrange;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkOrange;\r\n    }\r\n    &:focus {\r\n        background-color: ez-core.$ezDarkOrange;\r\n    }\r\n}\r\n\r\n\r\nbutton.ez-marketing-button-wide {\r\n    background-color: ez-core.$ezClockerNavy;\r\n    border-radius: 2px;\r\n    border: 1px solid ez-core.$ezBorderNavy;\r\n    display: inline-block;\r\n    width: 50%;\r\n    cursor: pointer;\r\n    color: ez-core.$ezClockerWhite;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n    font-weight: bold;\r\n    padding: 0.5rem;\r\n    text-decoration: none;\r\n    margin-bottom: 10px;\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverNavy;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n    &:focus {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n}\r\n\r\n\r\na.ez-learn-more-button {\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-weight: normal;\r\n    font-size: ez-responsive.$ezResponsiveNormalFontSize;\r\n    font-style: normal;\r\n    text-decoration: none;\r\n    color: ez-core.$ezClockerBlack;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    margin-top: 10px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: ez-core.$ezClockerYellow;\r\n    padding: 13px;\r\n    border-radius: 25px;\r\n    &:focus {\r\n        background-color: ez-core.$ezHoverYellow;\r\n        text-decoration: none;\r\n    }\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverYellow;\r\n        text-decoration: none;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkYellow;\r\n        text-decoration: none;\r\n    }\r\n}\r\n\r\na.ez-marketing-learn-more-button {\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-weight: normal;\r\n    font-size: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n    font-style: normal;\r\n    text-decoration: none;\r\n    color: ez-core.$ezClockerBlack;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    margin-top: 10px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: ez-core.$ezClockerYellow;\r\n    padding: 13px;\r\n    border-radius: 25px;\r\n    &:focus {\r\n        background-color: ez-core.$ezHoverYellow;\r\n        text-decoration: none;\r\n    }\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverYellow;\r\n        text-decoration: none;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkYellow;\r\n        font-style: normal;\r\n        text-decoration: none;\r\n    }\r\n}\r\n\r\n\r\n// Delete Major Button\r\nbutton.deleteMajorButton {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    color: #ffffff;\r\n    background-color: #CE0F0C;\r\n    border-color: #A60400;\r\n}\r\nbutton.deleteMajorButton:hover {\r\n    background-color: #FF0700;\r\n    color: #ffffff;\r\n}\r\nbutton.deleteMajorButton:active {\r\n    background-color: #BF3330;\r\n}\r\nbutton.deleteMajorButton:disabled {\r\n    color: #c0c0c0;\r\n    background-color: #FFf0f0;\r\n    border-color: #c0c0c0;\r\n    cursor: default;\r\n}\r\n\r\n// Mini Major\r\nButton Styles button.miniMajorButton {\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    font-weight: bold;\r\n    background-color: #ffc500;\r\n    border-color: #6d6e70;\r\n    color: #000000;\r\n    border-radius: 4px;\r\n}\r\nbutton.miniMajorButton:hover {\r\n    background-color: #ffdb64;\r\n}\r\nbutton.miniMajorButton:active {\r\n    border-color: #ffcc66;\r\n}\r\nbutton.miniMajorButton:disabled {\r\n    background-color: #ffdb64;\r\n    color: #c69800;\r\n    border-color: #c69800;\r\n}\r\n\r\n// Mini Normal Button Styles\r\nbutton.miniNormalButton {\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    font-weight: normal;\r\n    background-color: #ffc500;\r\n    border-color: #6d6e70;\r\n    color: #000000;\r\n    border-radius: 4px;\r\n}\r\nbutton.miniNormalButton:hover {\r\n    background-color: #ffdb64;\r\n}\r\nbutton.miniNormalButton:active {\r\n    border-color: #ffcc66;\r\n}\r\nbutton.miniNormalButton:disabled {\r\n    background-color: #ffdb64;\r\n    color: #c69800;\r\n    border-color: #c69800;\r\n}\r\n\r\n// Red warning button\r\nbutton.warningHeaderButton {\r\n    vertical-align: middle;\r\n    font-size: ez-responsive.$ezResponsiveSmallFontSize;\r\n    font-weight: bold;\r\n    background-color: #CE0F0C;\r\n    border-color: #A60400;\r\n    color: #ffffff;\r\n}\r\nbutton.warningHeaderButton:hover {\r\n    background-color: #FF0700;\r\n    color: #ffffff;\r\n}\r\nbutton.warningHeaderButton:active {\r\n    color: #ffffff;\r\n    background-color: #BF3330;\r\n}\r\nbutton.warningHeaderButton:disabled {\r\n    color: #c0c0c0;\r\n    background-color: #FFf0f0;\r\n    border-color: #c0c0c0;\r\n    font-weight: normal;\r\n}\r\n\r\n// Edit Button Styles\r\nbutton.editButton {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    margin: 2;\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    background-color: ez-core.$ezClockerNavy;\r\n    border-color: ez-core.$ezBorderNavy;\r\n    color: ez-core.$ezClockerWhite;\r\n    padding: 2px 4px;\r\n}\r\nbutton.editButton:hover {\r\n    background-color: ez-core.$ezHoverNavy;\r\n}\r\nbutton.editButton:active {\r\n    background-color: ez-core.$ezDarkNavy;\r\n}\r\nbutton.editButton:disabled {\r\n    cursor: default;\r\n    background-color: ez-core.$ezLightNavy;\r\n    color: ez-core.$ezNavyContainerDisabledTextColor;\r\n}\r\n\r\n// Small Button\r\nbutton.smallButton {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    margin: 0 2px 0 0;\r\n    padding: 2px;\r\n    border-color: #a60400;\r\n    background-color: #ff7673;\r\n}\r\nbutton.smallButton:hover {\r\n    background-color: #ff0700;\r\n    color: #ffffff;\r\n}\r\nbutton.smallButton:active {\r\n    background-color: #BF3330;\r\n}\r\nbutton.smallButton:disabled {\r\n    cursor: default;\r\n    color: #808080;\r\n    border-color: #c0c0c0;\r\n    padding: 2px;\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n// Mini Action Button Styles\r\nimg.miniButtonIcon {\r\n    width: 24px;\r\n    border-style: none;\r\n    vertical-align: middle;\r\n    padding-right: 4px;\r\n}\r\nbutton.miniActionButton {\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    padding: 2px;\r\n    margin: 0;\r\n    font-weight: bold;\r\n    border-radius: 2px;\r\n    color: #000000;\r\n    background-color: #ffc500;\r\n    border-color: #9b7800;\r\n    cursor: pointer;\r\n}\r\nbutton.miniActionButton:hover {\r\n    background-color: #ffdb64;\r\n}\r\nbutton.miniActionButton:active {\r\n    background-color: #c69800;\r\n}\r\nbutton.miniActionButton:disabled {\r\n    background-color: #c69800;\r\n    border-color: #808080;\r\n    color: #ffc500;\r\n    cursor: default;\r\n}\r\n\r\n\r\n// Mini delete action button\r\nbutton.miniDeleteActionButton {\r\n    font-size: ez-responsive.$ezResponsivePicoFontSize;\r\n    font-weight: bold;\r\n    border-radius: 4px;\r\n    padding: 2px;\r\n    margin: 0;\r\n    color: #ffffff;\r\n    background-color: #CE0F0C;\r\n    border-color: #A60400;\r\n    cursor: pointer;\r\n}\r\nbutton.miniDeleteActionButton:hover {\r\n    background-color: #FF0700;\r\n    color: #ffffff;\r\n}\r\nbutton.miniDeleteActionButton:active {\r\n    background-color: #BF3330;\r\n}\r\nbutton.miniDeleteActionButtonn:disabled {\r\n    color: #c0c0c0;\r\n    background-color: #FFf0f0;\r\n    border-color: #c0c0c0;\r\n    cursor: default;\r\n}\r\n\r\n\r\n// Action Button\r\nbutton.actionButton {\r\n    margin: 0;\r\n    background-color: #8df13c;\r\n    border-color: #439400;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n}\r\nbutton.actionButton:hover {\r\n    background-color: #caff9e;\r\n}\r\nbutton.actionButton:active {\r\n    color: #caff9e;\r\n    background-color: #439400;\r\n}\r\nbutton.actionButton:disabled {\r\n    cursor: default;\r\n    background-color: #caff9e;\r\n    border-color: #8df13c;\r\n    font-weight: normal;\r\n    color: #808080;\r\n}\r\n\r\n\r\n// Super-Action Button Styles\r\nbutton.superActionButton {\r\n    margin: 0;\r\n    background-color: #0f4777;\r\n    border-color: #6d6e70;\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n    font-size: ez-responsive.$ezResponsiveMediumFontSize;\r\n    padding: 6px 24px;\r\n}\r\nbutton.superActionButton:hover {\r\n    background-color: #0d58a6;\r\n}\r\nbutton.superActionButton:active {\r\n    background-color: #0d58a6;\r\n}\r\nbutton.superActionButton:disabled {\r\n    cursor: default;\r\n    background-color: #5387bd;\r\n    border-color: #0f4777;\r\n    font-weight: normal;\r\n    color: #0f4777;\r\n}\r\n\r\n\r\n/* Tab Buttons */\r\n\r\n// Tab Button\r\n.ezTabButton {\r\n    margin: 0 4px 0 0;\r\n    min-height: 32;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #000000;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    background-color: #c0c0c0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    box-shadow: none;\r\n}\r\n.ezTabButton:HOVER {\r\n    background-color: #e0e0e0;\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n.ezTabButton:ACTIVE {\r\n    background-color: #ffffff;\r\n    border-bottom-width: 2px;\r\n    border-bottom-color: #ffffff;\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n.ezTabButton:FOCUS {\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n\r\n\r\n// Active Tab Button\r\n.ezTabButtonActive {\r\n    margin: 0 4px 0 0;\r\n    min-height: 32;\r\n    font-weight: bold;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n.ezTabButtonActive:HOVER {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n.ezTabButtonActive:ACTIVE {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n.ezTabButtonActive:FOCUS {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Paper Buttons */\r\n\r\n// Navigation Button\r\npaper-button.ez-navigation-button {\r\n    max-height: $ezNavButtonMaxHeight;\r\n    max-width: $ezNavButtonMaxWidth;\r\n    min-width: $ezNavButtonMinWidth;\r\n    font-size: $ezNavButtonFontSize;\r\n    font-weight: $ezNavButtonFontWeight;\r\n    background-color: $ezNavButtonColor;\r\n    color: $ezNavButtonTextColor;\r\n    text-transform: $ezNavButtonTextTransform;\r\n}\r\npaper-button.ez-navigation-button>paper-ripple {\r\n    color: ez-core.$ezWhite;\r\n}\r\npaper-button.ez-navigation-button:hover {\r\n    background-color: $ezNavButtonColorHover;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n// Sign out Button\r\npaper-button.ez-signout-button {\r\n    text-transform: $ezSignOutButtonTextTransform;\r\n    max-height: $ezSignOutButtonMaxHeight;\r\n    max-width: $ezSignOutButtonMaxWidth;\r\n    min-width: $ezSignOutButtonMinWidth;\r\n    font-size: $ezSignOutButtonFontSize;\r\n    font-weight: $ezSignOutButtonFontWeight;\r\n    background-color: $ezSignOutButtonColor;\r\n    color: $ezSignOutButtonTextColor;\r\n}\r\npaper-button.ez-signout-button>paper-ripple {\r\n    color: ez-core.$ezWhite;\r\n}\r\npaper-button.ez-signout-button:hover {\r\n    background-color: $ezSignOutButtonHoverColor;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n// Select plan button\r\npaper-button.ez-select-plan-button {\r\n    max-width: $ezSelectPlanButtonMaxWidth;\r\n    min-width: $ezSelectPlanButtonMinWidth;\r\n    max-height: $ezSelectPlanBtnMaxHeight;\r\n    font-size: $ezSelectPlanBtnFontSize;\r\n    font-weight: $ezSelectPlanBtnFontWeight;\r\n    background-color: $ezSelectPlanBtnColor;\r\n    color: $ezSelectPlanBtnTextColor;\r\n    text-transform: $ezSelectPlanTextTransform;\r\n}\r\npaper-button.ez-select-plan-button>paper-ripple {\r\n    color: ez-core.$ezBorderGreen;\r\n}\r\npaper-button.ez-select-plan-button:hover {\r\n    background-color: $ezSelectPlanBtnHoverColor;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* INPUT BUTTONS */\r\n\r\n// ez-major button\r\ninput[type=\"button\"].ez-major-button {\r\n    background-color: #ff9900;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"button\"].ez-major-button:hover {\r\n    background-color: #ffcc66;\r\n}\r\ninput[type=\"button\"].ez-major-button:active {\r\n    background-color: #ff9933;\r\n}\r\ninput[type=\"button\"].ez-action-button {\r\n    background-color: #8df13c;\r\n    border-radius: 2px;\r\n    border: 1px solid #439400;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\n\r\n// ez-marketing-button\r\ninput[type=\"button\"].ez-marketing-input-button {\r\n    background-color: ez-core.$ezClockerNavy;\r\n    border-radius: 2px;\r\n    border: 1px solid ez-core.$ezBorderNavy;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: ez-core.$ezClockerWhite;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n    &:hover {\r\n        background-color: ez-core.$ezHoverNavy;\r\n    }\r\n    &:active {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n    &:focus {\r\n        background-color: ez-core.$ezDarkNavy;\r\n    }\r\n}\r\n\r\n// ez-action-button\r\ninput[type=\"button\"].ez-action-button {\r\n    background-color: #8df13c;\r\n    border-radius: 2px;\r\n    border: 1px solid #439400;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"button\"].ez-action-button:hover {\r\n    background-color: #caff9e;\r\n}\r\ninput[type=\"button\"].ez-action-button:active {\r\n    color: #caff9e;\r\n    background-color: #439400;\r\n}\r\n\r\n// ez-edit-button\r\ninput[type=\"button\"].ez-edit-button {\r\n    background-color: #f0f0f0;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    padding: 4px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"button\"].ez-edit-button:hover {\r\n    background-color: #edf6ff;\r\n}\r\ninput[type=\"button\"].ez-edit-button:active {\r\n    background-color: #c0c0c0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
